import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-39246e5e"),n=n(),_popScopeId(),n)
const _hoisted_1 = {
  key: 0,
  class: "project"
}
const _hoisted_2 = { class: "project-page-title" }
const _hoisted_3 = {
  key: 0,
  class: "project-start-date"
}
const _hoisted_4 = { class: "project-page-summary" }
const _hoisted_5 = {
  key: 1,
  class: "project-page-link"
}
const _hoisted_6 = ["href"]
const _hoisted_7 = ["innerHTML"]
const _hoisted_8 = { key: 1 }
const _hoisted_9 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", null, "No project found.", -1))
const _hoisted_10 = [
  _hoisted_9
]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_ctx.project)
    ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
        _createElementVNode("div", _hoisted_2, [
          _createElementVNode("h2", null, _toDisplayString(_ctx.project.project_title), 1)
        ]),
        (_ctx.project.project_start_date)
          ? (_openBlock(), _createElementBlock("div", _hoisted_3, [
              _createElementVNode("h3", null, " DATE STARTED: " + _toDisplayString(_ctx.project.project_start_date.toLocaleDateString("en-GB")), 1)
            ]))
          : _createCommentVNode("", true),
        _createElementVNode("div", _hoisted_4, [
          _createElementVNode("p", null, _toDisplayString(_ctx.project.project_description), 1)
        ]),
        (_ctx.project.project_link)
          ? (_openBlock(), _createElementBlock("div", _hoisted_5, [
              _createElementVNode("p", null, [
                _createElementVNode("a", {
                  href: _ctx.project.project_link,
                  target: "_blank",
                  rel: "noopener"
                }, "View project on Github ", 8, _hoisted_6)
              ])
            ]))
          : _createCommentVNode("", true),
        _createElementVNode("div", {
          class: "project-page-content",
          innerHTML: _ctx.sanitizedContent
        }, null, 8, _hoisted_7)
      ]))
    : (_openBlock(), _createElementBlock("div", _hoisted_8, _hoisted_10))
}